import { intlMessagesEn } from 'src/app/locale/en';

export const LOCALE_EN = 'en-gb';

export const MESSAGES = {
  [LOCALE_EN]: intlMessagesEn
};
